/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {clearProfilePhoto} from '../api'

export const useMutationClearProfilePhoto = createReactQueryMutationHook('clearProfilePhoto', clearProfilePhoto)
